document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".banner-swiper", {
    loop: false,
    slidesPerView: 4,
    spaceBetween: 28,
    navigation: {
      nextEl: ".swiper-button-next-banner",
      prevEl: ".swiper-button-prev-banner",
    },
    scrollbar: {
      el: ".swiper-scrollbar-banner",
      hide: false,
      draggable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 8,
      },
      0: {
        slidesPerView: 1.1,
        spaceBetween: 16,
      },
    },
  });
});
